import React from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout';
import {
  HomePage,
  FloorPlanPage,
  RegisterPage,
  SpeakersPage,
  VenuePage,
  LegalPage,
  AdminPage,
  AdminSalesPage,
  AdminCrmPage,
  AdminAutomationsPage,
  AdminSpeakersPage,
  AdminSocialPage,
  AdminOperationsPage,
  AdminConfigurePage,
  AdminTeamPage,
  CheckInPage,
  RegistrationCompletePage,
  MyIiabPage,
  BadgeResolverPage,
  MyIiabWelcomePage,
  ExhibitorPortalPage,
  SpeakerApplyPage,
  UnsubscribePage,
  VendorPerksCounterPage,
  NotFoundPage,
} from './pages';

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: 'floorplan',
        element: <FloorPlanPage />,
      },
      {
        path: 'register',
        element: <RegisterPage />,
      },
      {
        path: 'my-iiab',
        element: <MyIiabPage />,
      },
      {
        path: 'my-iiab/welcome',
        element: <MyIiabWelcomePage />,
      },
      {
        path: 'b/:badgeCode',
        element: <BadgeResolverPage />,
      },
      {
        path: 'my-pass',
        element: <Navigate to="/my-iiab" replace />,
      },
      {
        path: 'portal',
        element: <Navigate to="/exhibitor-portal" replace />,
      },
      {
        path: 'portal/attendee',
        element: <Navigate to="/my-iiab" replace />,
      },
      {
        path: 'register/complete',
        element: <RegistrationCompletePage />,
      },
      {
        path: 'registration-complete',
        element: <RegistrationCompletePage />,
      },
      {
        path: 'speakers',
        element: <Navigate to="/#speakers" replace />,
      },
      {
        path: 'apply',
        element: <SpeakerApplyPage />,
      },
      {
        path: 'speakers/apply',
        element: <SpeakerApplyPage />,
      },
      {
        path: 'venue',
        element: <Navigate to="/#venue" replace />,
      },
      {
        path: 'terms',
        element: <LegalPage />,
      },
      {
        path: 'privacy',
        element: <Navigate to="/terms?tab=privacy" replace />,
      },
      {
        path: 'admin',
        element: <AdminPage />,
        children: [
          {
            index: true,
            element: <AdminSalesPage />,
          },
          {
            path: 'sales',
            element: <AdminSalesPage />,
          },
          {
            path: 'crm',
            element: <AdminCrmPage />,
          },
          {
            path: 'automations',
            element: <AdminAutomationsPage />,
          },
          {
            path: 'automate',
            element: <Navigate to="/admin/automations" replace />,
          },
          {
            path: 'speakers',
            element: <AdminSpeakersPage />,
          },
          {
            path: 'social',
            element: <AdminSocialPage />,
          },
          {
            path: 'operations',
            element: <AdminOperationsPage />,
          },
          {
            path: 'reports',
            element: <Navigate to="/admin/operations?tab=reports" replace />,
          },
          {
            path: 'configure',
            element: <AdminConfigurePage />,
          },
          {
            path: 'team',
            element: <AdminTeamPage />,
          },
          {
            path: '*',
            element: <Navigate to="/admin/sales" replace />,
          },
        ],
      },
      {
        path: 'checkin',
        element: <CheckInPage />,
      },
      {
        path: 'exhibitor-portal',
        element: <ExhibitorPortalPage />,
      },
      {
        path: 'portal/exhibitor',
        element: <ExhibitorPortalPage />,
      },
      {
        path: 'unsubscribe',
        element: <UnsubscribePage />,
      },
      {
        path: 'counter/perks',
        element: <VendorPerksCounterPage />,
      },
      {
        path: 'vendor/perks',
        element: <VendorPerksCounterPage />,
      },
      {
        path: '*',
        element: <NotFoundPage />,
      },
    ],
  },
];
